import { getRequest } from 'utils/api'

export const keepAlive = () => getRequest('account/keepalive')
